export { default as UpsiActivityHistory } from './UpsiActivityHistory.vue';
export { default as UpsiDialogBanner } from './UpsiDialogBanner.vue';
export { default as UpsiSummaryList } from './UpsiSummaryList.vue';
export { default as UpsiPersonStrip } from './UpsiPersonStrip.vue';
export { default as UpsiRemarksBlock } from './UpsiRemarksBlock.vue';
